import { Col, Container, Row, Typography } from 'darrius';
import { BenefitsData } from '../../../data/home/homeData';

import styles from './Benefits.module.scss';

export const Benefits = () => {
  return (
    <Container className={styles.benefits}>
      <Row className="space-top">
        <Col className="col-sm-12">
          <Row className="middle-md">
            <Col className="col-sm-12">
              <Typography.Title as="h2" size="3xl">
                Benefícios para você
              </Typography.Title>
              <Row className="middle-sm space-top">
                <Col className="col-sm-12 col-md-4 center-sm">
                  <img
                    src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/partner-phone.svg`}
                    alt="Icone de economia"
                  />
                  <Row
                    className={`${styles['paragraph__benefits']} center space-bottom`}
                  >
                    <Col className="col-sm-10">
                      <Typography.Subtitle as="h3" size="m">
                        {BenefitsData.descriptionImageOne}
                      </Typography.Subtitle>
                    </Col>
                  </Row>
                </Col>
                <Col className="col-sm-12 col-md-4 center-sm">
                  <img
                    src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/partner-comunication.svg`}
                    alt="Icone de comunicação"
                  />
                  <Row className="center space-bottom">
                    <Col className="col-sm-10">
                      <Typography.Subtitle as="h3" size="m">
                        {BenefitsData.descriptionImageTwo}
                      </Typography.Subtitle>
                    </Col>
                  </Row>
                </Col>
                <Col className="col-sm-12 col-md-4 center-sm">
                  <img
                    className="partner-money"
                    src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/partner-money.svg`}
                    alt="Icone de celular"
                  />
                  <Row className="center space-bottom">
                    <Col className="col-sm-10">
                      <Typography.Subtitle as="h3" size="m">
                        {BenefitsData.descriptionImageThree}
                      </Typography.Subtitle>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};
